<script setup>
function onClick() {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}
</script>

<template>
  <button class="scroll-top" @click="onClick"></button>
</template>

<style lang="postcss" scoped>
.scroll-top {
  border-radius: 50%;
  display: flex;
  overflow: hidden;
  cursor: pointer;
  transition: var(--default-transition) opacity;
  background-image: url('~/assets/images/arrow-top.svg');
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;

  &:hover {
    opacity: 0.6;
  }
}
</style>
